var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_78_270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6724 4.7155L21.6073 3.65047C21.1686 3.21173 20.4523 3.21173 20.0097 3.65047L8.8419 14.8221L2.9917 8.97191C2.55296 8.53312 1.83666 8.53312 1.39414 8.97191L0.329056 10.0369C-0.109685 10.4757 -0.109685 11.192 0.329056 11.6345L8.03937 19.3447C8.26066 19.566 8.54562 19.6785 8.8344 19.6785C9.12319 19.6785 9.41192 19.566 9.62948 19.3447L22.6611 6.3131C23.1111 5.86686 23.1111 5.15434 22.6724 4.7155Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_78_270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.f317818812472a3a8f6f8f83029e7d2a.svg";
export { ForwardRef as ReactComponent };